import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { ANALYTICS } from '../../analytics/constants';
import { PayloadProps, track } from '../../analytics/index';
import { InternationalIcon } from '../../assets/svg/InternationalIcon';
import { DateFilter } from '../../components/table/components/date-filter';
import { ViewWrapper } from '../../components/view-wrapper';
import { CONSTANTS } from '../../config/constants';
import { useAuth } from '../../hooks/useAuth';
import { useMerchant } from '../../hooks/useMerchant';
import { Filters } from '../../models/table';
import { OutboundService } from '../../services/outbound';
import { getRoleLabelById } from '../../utils/common';
import { defaultFilters, defaultPagination } from '../../utils/defaults';
import ModalInternational from './components/modal';
import { InternationalTable } from './components/table';
import { ButtonHead, ContainerButton, HeadContainer, TableFilterHeader, TitlePage } from './styles';

const customDefaultFilters: Filters = {
	...defaultFilters,
	typeSelected: '',
	international: true
};

const International = () => {
	const { merchantSelected } = useMerchant();
	const { user } = useAuth();
	const [filters, setFilters] = useState(customDefaultFilters);
	const [pagination, setPagination] = useState(defaultPagination);
	const [total, setTotal] = useState(0);
	const [show, setShow] = useState<boolean>(false);

	const today = new Date();

	const pastDate = new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000);

	const {
		data: table,
		isFetching,
		isFetched,
		isLoading,
		refetch,
	} = useQuery({
		enabled: !!merchantSelected,
		useErrorBoundary: true,
		keepPreviousData: true,
		queryKey: [
			CONSTANTS.services.directDebitMx.getTableInfo,
			merchantSelected?.code,
			pagination,
			filters,
		],
		queryFn: () =>
			OutboundService.getAllOutbound({
				merchantCode: merchantSelected?.code as string,
				pagination,
				filters: {
					...filters,
					dateRange: {
						from: filters?.dateRange?.from || pastDate,
						to: filters?.dateRange?.to || today,
					},
				},
			}),
		onSuccess: (data) => {
			if (data) setTotal(data.total);
		},
	});

	useEffect(() => {
		setFilters(customDefaultFilters);
		setPagination(defaultPagination);
	}, [merchantSelected]);

	useEffect(() => {
		const trackInfo: PayloadProps = {
			type: 'screen',
			pageView: ANALYTICS.international.page_view,
			source: 'GTM',
		};
		track(trackInfo);
	}, []);

	const roleIsAllowed =
		merchantSelected &&
		(getRoleLabelById(merchantSelected?.role_id, merchantSelected?.role_id) === 'ETpay' ||
			user?.email.includes('@etpay.com'));

	const onClose = () => {
		setShow(false);
		refetch();
	};

	return (
		<ViewWrapper title="Internacionales" isLoading={isFetching || isLoading}>
			<>
				<HeadContainer>
					<TitlePage>
						<InternationalIcon /> Remesas
					</TitlePage>

					<ContainerButton>
						{roleIsAllowed && (
							<>
								<ButtonHead onClick={() => setShow(true)}>Nuevo pago</ButtonHead>
							</>
						)}
					</ContainerButton>
				</HeadContainer>

				{show && <ModalInternational onClose={onClose} />}
				<TableFilterHeader>
					<DateFilter
						filters={filters}
						onFilterChange={setFilters}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</TableFilterHeader>
				<InternationalTable
					data={table?.tableInfo || []}
					isLoading={isFetching && !isFetched}
					stateList={table?.typeOfStatus || []}
					filters={filters}
					onFilterChange={setFilters}
					pagination={pagination}
					setPagination={setPagination}
					totalResults={total}
					refetch={refetch}
				/>
			</>
		</ViewWrapper>
	);
};

export { International };
